import React from "react";
import { withRouter } from 'react-router-dom';
import { Table, Icon, Image, Button } from 'semantic-ui-react';
import { dispatch } from '@rematch/core';
import EllipsisTooltip from "../../../../common/EllipsisTooltip";
import LoadingComponent from "../../../../common/LoadingComponent";
import NoTeam from './../../../../../images/grafix-banner/gfx-no-teams.svg';
import CommonTable from './../../../../drive/Table/TableLayout';
import TeamListViewJson from './TeamListViewJSON.json'
import _ from 'lodash';
import { toastr } from 'react-redux-toastr';

let timer = 0;
let delay = 200;
let prevent = false;

class TeamsListView extends React.Component {
  constructor(props) {
    super(props);
    this.state = {
      tableHeader: TeamListViewJson,
      listData: "",
      filterData: "",
      totalDataCount: props.subOrgs && props.subOrgs.total ? props.subOrgs.total : props.subOrgs && props.subOrgs.data && props.subOrgs.data.length,
      _limit: 10,
      _sort: "name", // Change made for KLM-8966
      showListView:false,
      processingDelete:false,
    }

  }


  handleClick(event, subOrg, key) {
    let thisClick = this;
    timer = setTimeout(function () {
      if (!prevent) {
        thisClick.cardClick(event, subOrg, key);
      }
      prevent = false;
    }, delay);
  }

  componentWillReceiveProps(nextProps) {
    if (this.props.subOrgs !== nextProps.subOrgs) {

      this.setState({
        listData: nextProps.subOrgs && nextProps.subOrgs.data,
        filterData: nextProps.subOrgs && nextProps.subOrgs.data,
        totalDataCount: nextProps.subOrgs && nextProps.subOrgs.total ? nextProps.subOrgs.total : nextProps.subOrgs && nextProps.subOrgs.data && nextProps.subOrgs.data.length,
        showListView:true,
      })
    }
  }

  componentWillMount() {
    dispatch.community.addMainAreaContext('ORGANIZATION');
    if (this.props.match.params.teamId === this.props.match.params.workspaceId) {
      let payload = {
        organizationId: this.props.selectedOrganisation.id,
        accountId: this.props.selectedAccount._id
      };
      dispatch.organizationUnit.getAssignedSubOrgAsync(payload);
      dispatch.organizationUnit.getOrgByIdAsync(this.props.match.params.workspaceId);
    }
    else {
      let payload = {
        teamId: this.props.match.params.teamId
      };
      dispatch.organizationUnit.getSubOrgByParentIdAsync(payload);
      dispatch.organizationUnit.getSubOrgByIdAsync(this.props.match.params.teamId);
    }
    dispatch.users.storeUnitId(this.props.match.params.teamId);
  }

  async componentDidUpdate (prevProps) {
    const { match, selectedOrganisation, selectedAccount, dispatch } = this.props;
    if (match.params.teamId !== prevProps.match.params.teamId || 
        match.params.workspaceId !== prevProps.match.params.workspaceId ) {
        let query = {
          $sort: { createdAt: 1 },
          $skip: 0,
          $limit: this.props.teamsListViewFlag ? 10 : 50
        }
        await dispatch.community.addMainAreaContext('ORGANIZATION');
        dispatch.organizationTab.getUsersTreeAsync({ id: match.params.teamId, accountId: match.params.accountId });
        dispatch.users.storeUnitId(match.params.teamId);
        let invitePayload = {
          query: query,
          organizationId: selectedOrganisation.id,
          referenceId: match.params.teamId
        };
        dispatch.invite.getInvitesAsync(invitePayload);
      if (match.params.teamId === match.params.workspaceId) {
        let payload = {
          organizationId: selectedOrganisation.id,
          accountId: selectedAccount._id
        };
        dispatch.organizationUnit.getAssignedSubOrgAsync(payload);
        dispatch.organizationUnit.getOrgByIdAsync(match.params.workspaceId);
      } else {
        let payload = {
          teamId: match.params.teamId
        };
        dispatch.organizationUnit.getSubOrgByParentIdAsync(payload);
        dispatch.organizationUnit.getSubOrgByIdAsync(match.params.teamId);
      }
    }
  }

  cardClick = async (event, subOrg, key) => {
    await dispatch.users.storeUnitId(subOrg._id);
    await dispatch.organizationUnit.addSelectedSubOrg(subOrg);
    await dispatch.organizationTab.getUsersTreeAsync({ id: subOrg._id, accountId: this.props.match.params.accountId, organizationId: this.props.selectedOrganisation.id });
    await dispatch.organizationUnit.getSubOrgResourcePaneAsync(subOrg._id);
    await dispatch.organizationTab.getSelectedSubOrgUsersAsync(subOrg._id);
    await dispatch.initiatives.getInviteBySubOrgAsync(subOrg._id)
    await dispatch.organizationUnit.showResourecePane("Home");
    await dispatch.lifeCycle.splitAt("60%")
    await dispatch.lifeCycle.setLibraryCardIndex(key);
    await dispatch.app.setCollapsedResourcePaneIndexTemp(null)
    await dispatch.organizationUnit.showDeleteDisabled(false)

  }

  handleDoubleClick(event, subOrg, key) {
    clearTimeout(timer);
    prevent = true;
    this.doDoubleClickAction(event, subOrg, key);
  }

  doDoubleClickAction(event, subOrg, key) {
    this.cardClick(event, subOrg, key);
    dispatch.lifeCycle.splitAt("60%");
  }

  cardSubOrgAdd = async (e, subOrg) => {
    const history = this.props.history;
    e.stopPropagation();
    await dispatch.users.storeUnitId(subOrg._id);
    await dispatch.app.setCollapsedResourcePaneIndexTemp(null)
    await dispatch.organizationUnit.showResourecePane(null);
    await dispatch.organizationUnit.addSelectedSubOrg(subOrg);
    let ops = "Add Sub-Team"
    dispatch.community.addBreadCrumbOps(ops);
    history.push({
      pathname: `/app/${this.props.match.params.accountId}/_ws/${this.props.match.params.workspaceId}/_cm/createTeam/addTeamListView/${subOrg._id}/${subOrg.parentOrganizationId}`,
    });
  }


  async handleClickTeamDetailsPage(e, subOrg) {
    e.stopPropagation();
    await dispatch.users.storeUnitId(subOrg._id);
    await dispatch.app.setCollapsedResourcePaneIndexTemp(null)
    await dispatch.organizationUnit.showResourecePane(null);
    await dispatch.organizationUnit.addSelectedSubOrg(subOrg);
    let ops = "Add Sub-Team"
    dispatch.community.addBreadCrumbOps(ops);
    this.props.history.push({
      pathname: `/app/${this.props.match.params.accountId}/_ws/${this.props.match.params.workspaceId}/_cm/teamDetail/${subOrg._id}`,
    });
  }

  cardUnitUsersAdd = async (e, subOrg) => {
    const history = this.props.history;
    e.stopPropagation();
    await dispatch.app.setCollapsedResourcePaneIndexTemp(null)
    await dispatch.organizationUnit.showResourecePane(null);
    await dispatch.organizationUnit.addSelectedSubOrg(subOrg);
    await dispatch.community.addMainAreaContext('InviteAndAddUsers');
    await dispatch.community.setAddUserContextData('Teams');
    await dispatch.users.storeUnitId(subOrg._id);
    let ops = "Add/Invite Sub-Team Users"
    dispatch.community.addBreadCrumbOps(ops);
    history.push({
      pathname: `/app/${this.props.match.params.accountId}/_ws/${this.props.match.params.workspaceId}/_cm/addUser/addUserInTeamList/${subOrg._id}/${subOrg.parentOrganizationId}`,
    });
  }
  redirectTeamCreate() {
    const history = this.props.history;
    history.push(`/app/${this.props.selectedAccount._id}/_ws/${this.props.selectedOrganisation.id}/_cm/createTeam/addTeamListView/${this.props.selectedSubOrg ? this.props.selectedSubOrg._id : this.props.selectedOrganisation.id}/${this.props.selectedSubOrg ? this.props.selectedSubOrg.parentOrganizationId : this.props.selectedOrganisation.id}`);
  }

  addColumn = (newColumns) => {
    if (newColumns) {
      this.setState({ tableHeader: newColumns })
    }
  };

  async deleteSubOrgMain(event,subOrg) {
    try {
        await dispatch.organizationUnit.addSelectedSubOrg(subOrg);
        await dispatch.organizationUnit.checkSuborganizationBeforeDelete(subOrg._id);
        // this.setState({ processingDelete: true });
        let message = <div className="confirmMessage">
            <h3>Delete Team</h3>
            <label>{subOrg.name}</label>
            <p>Are you sure that you wish to delete this team?</p>
            <span >This action is not reversible</span>
        </div>
        
        toastr.confirm(message, {
            onOk: async () => {
                this.setState({ processingDelete: true });
                await dispatch.organizationUnit.deleteSubOrganizationMainAsync(subOrg);
                this.setState({ processingDelete: false });
            }
        });
        this.setState({ processingDelete: false });
    }
    catch (err) {
        const toastrConfirmOptions = {
            disableCancel: true
        };
        toastr.confirm(err.message, toastrConfirmOptions, {
            onOk: () => {
            }
        });
        this.setState({ processingDelete: false });
    }
  }
  
  handleDropDownItem = (event, type, data, clickedCount) => {
    if (type.text === "Details") {
      this.handleClickTeamDetailsPage(event, data)
    }
    if (type.text === "View") {
      this.handleClick(event, data)
    }
    if (type.text === "Add Team") {
      this.cardSubOrgAdd(event, data)
    }
    if (type.text === "Add / Invite User") {
      this.cardUnitUsersAdd(event, data)
    }
    if(type.text === "Delete Team") {
      this.deleteSubOrgMain(event, data);
    }

  }

  render() {
    let checktTeam = !this.props.match.params.teamId || (this.props.match.params.teamId === this.props.selectedOrganisation.id)
    return (
      <div>
        <LoadingComponent active={this.state.processingDelete} message="Deleting Team..."/>
        {this.state.showListView && this.props.subOrgs && this.props.subOrgs.data && this.props.subOrgs.data.length === 0 ?
          <div className="w_50 text-center mar_0_auto pad_20">
            <Image src={NoTeam} /> <br />
            <strong as="h3" > {
              checktTeam ? "No teams to display" : "No sub teams to display"
            } </strong><br /><br />
            <strong > Communities are all about communicating, <br /> Collaborating and Managing. Start creating your <br />own teams.</strong><br /><br />
            <Button className="button-submit" onClick={(e) => this.redirectTeamCreate(e)}
              disabled={this.props.selectedOrganisation.role === 'Manager' && this.props.orgUniqueId === this.props.selectedOrganisation.id}>
              {!checktTeam ? "Create Sub Team" : "Create Team"}
            </Button>
          </div>
          :
          <CommonTable
            tableHeader={this.state.tableHeader}
            listData={this.state.listData}
            searchable={false}
            selection={true}
            totalCount={this.state.totalDataCount}
            loading={false}
            limit={this.state._limit}
            sort={this.state._sort}
            //onQueryChange={this.onQueryChange}
            addColumn={this.addColumn}
            handleDropDownItem={this.handleDropDownItem}
            handleTableComponent={this.handleTableComponent}
          />
        }
      </div>
    );
  }
}
export default withRouter(TeamsListView)




